import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { UpcomingTripsContent } from './upcoming-trips.style';
import TripCard from '../../common/trip-card';
import endpoints from '../../../services/endpoints';
import TripCardSkeleton from '../../common/trip-card/trip-card-skeleton';
import { CustomButton, CustomIcon, CustomText, WrapperContainer } from '@corporate-trip-planner-fe/ui-styles';
import { ArrowForward } from '@mui/icons-material';
// Future scope
// Allow filtering by: City / Region , Company, Trip Type (Corporate Retreat, Offsite, Conference, Adventure, etc.)
var UpcomingTrips = function (_a) {
    var trips = _a.trips, inProgress = _a.inProgress;
    var navigate = useNavigate();
    var handleViewAllTrips = function () {
        navigate('/view-all-trips');
    };
    var handleTripClick = function (event) {
        var _a;
        var tripId = (_a = event.target.closest("[data-trip-id]")) === null || _a === void 0 ? void 0 : _a.getAttribute("data-trip-id");
        if (tripId) {
            navigate("".concat(endpoints.web.tripDetails, "/").concat(tripId));
        }
    };
    return (_jsxs(WrapperContainer, { "$flexDirection": 'column', children: [_jsxs(WrapperContainer, { "$justifyContent": 'space-between', "$responsive": false, "$padding": '0', children: [_jsx(CustomText, { "$fontWeight": 'bold', children: "Upcoming Trips" }), _jsxs(CustomButton, { onClick: handleViewAllTrips, color: 'grey', backgroundColor: '#ededed', padding: '0.25rem 0.5rem', "$backgroundColorHover": '#aeacac', "$colorHover": '#fff', children: ["View All", _jsx(CustomIcon, { "$fontSize": "12px", children: _jsx(ArrowForward, { fontSize: "inherit" }) })] })] }), inProgress && _jsx(TripCardSkeleton, {}), trips && _jsx(UpcomingTripsContent, { onClick: handleTripClick, children: trips.map(function (trip) { return (_jsx(TripCard, { trip: trip }, trip.id)); }) })] }));
};
export default UpcomingTrips;
